export const RemoteTextInput = {
  mounted() {
    this.handleEvent("send_text", () => {
      this.el.reset();
    });
  },
};
